// Set variables from .env file references
const geturl = window.location.origin
const clientId = process.env.REACT_APP_MSAL_KEY
// const tenantId = process.env.REACT_APP_TENANTID

export const msalConfig = {
  auth: {
    clientId: `${clientId}`,
    authority: `https://login.microsoftonline.com/organizations`,
    knownAuthorities: [],
    redirectUri: `${geturl}/login`,
    postLogoutRedirectUri: `${geturl}/login`,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
}

// Add the endpoints hereyfor Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

export const extractDomain = (url) => {
  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;

    // Match localhost, IPs, or normal domains
    const match = hostname.match(
      /^([a-zA-Z0-9.-]+|\blocalhost\b|\b\d{1,3}(?:\.\d{1,3}){3}\b)$/
    );

    const domain = match ? match[0] : null;
    return domain;
  } catch (err) {
    console.error("Invalid URL:", url, err);
    return null;
  }
};
export const getOktaConfig = (tableConfig) => {
  localStorage.setItem('issuer', tableConfig?.authorityURL);
  return {
    issuer: tableConfig?.authorityURL,
    clientId: tableConfig?.clientId,
    redirectUri: window.location.origin+(tableConfig?.redirectUri || process.env.REACT_APP_OKTA_REDIRECT_URI),
    scopes: tableConfig?.scopes || ['openid', 'profile', 'email'],
    pkce: tableConfig.pkce ?? true,
    responseType: tableConfig?.responseType || ['code'],
  };
};
export const getEntraConfig = (tableConfig) => {
  // tableConfig should have: { issuer, clientId, redirectUri, scopes, pkce }
  if (!tableConfig) {
    return {
      authority: 'https://example.com',
      clientId: 'dummy',
      knownAuthorities: [],
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    };
  }

  return {
    clientId: tableConfig?.clientId,
    authority: tableConfig?.authorityURL,
    knownAuthorities: [],
    redirectUri: tableConfig?.redirecturi || `${window.location.origin}/login`,
    postLogoutRedirectUri: tableConfig?.PostLogoutRedirecturi || `${window.location.origin}/login`,
  };
};